<template>
  <div class="p-3 bg-white">
    <div id="EditTransferFormContainer" class="vs-con-loading__container">
      <shared-transfers-edit
        @editTransferSuccess="editTransferSuccess"
      ></shared-transfers-edit>

      <div class="text-center">
        <vs-button id="editTransferButton" class="m-2" color="primary" type="filled" @click.prevent="updateTransfer">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelEditTransfer">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import SharedTransfersEdit from '@/views/Shared/Transfers/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Transfers.Edit',
  components: {
    SharedTransfersEdit
  },
  mounted () {
    EventBus.$emit('initTransferGetFormData', {id: this.$route.params.id})
  },
  methods: {
    updateTransfer () {
      EventBus.$emit('initUpdateTransfer')
    },
    editTransferSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_transfers_table')
      window.close()
    },
    cancelEditTransfer () {
      this.$windowOpenerHelper.notifyOpener('reload_transfers_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
